import * as React from "react";
import { SVGProps } from "react";

const PaperPlane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.705 4.592c.311-1.406-.996-2.675-2.411-2.265L3.637 6.883l-.151.05c-1.47.553-1.695 2.6-.319 3.447l6.476 3.986 3.896 6.454.087.133c.914 1.28 2.936.97 3.397-.58l4.645-15.64.037-.141Zm-1.92-.839a.427.427 0 0 1 .445.552l-4.645 15.64-.03.076a.418.418 0 0 1-.732.024l-3.688-6.109 5.252-5.286.073-.085a.75.75 0 0 0-.076-.976l-.084-.072a.75.75 0 0 0-.977.076l-5.245 5.28-6.124-3.77-.066-.05c-.238-.216-.158-.635.168-.73l15.656-4.555.073-.015Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.5}
    />
  </svg>
);

export default PaperPlane;
